import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { MMKVEdTechStoreKeyMap } from '../mmkv/mmkvEdTechStoreKeyMap';
import { mmkvEdTechProductPersistence, zustanEdTechProductStorage } from '../mmkv/mmkvEdTechProductStore';
import { IActionDataModel,IProductDetail ,IEdTechContentModel} from '@ninjacart/nc-nk-core';


type EdTechPreferenceStore = {
  productViewAll: Array<IActionDataModel<IEdTechContentModel>>;
  setProductViewAll: (payload: Array<IActionDataModel<IEdTechContentModel>>) => void;
  learningCourseWebViewUrl: string;
  setLearningCourseWebViewUrl: (learningCourseWebViewUrl: string) => void;
  myCourses: Array<IActionDataModel<IEdTechContentModel>>;
  setMyCourses: (payload: Array<IActionDataModel<IEdTechContentModel>>) => void;
  instructorList: Array<IActionDataModel>;
  setInstructorList: (payload: Array<IActionDataModel>) => void;
  cart: IProductDetail[];
  addToCart: (items: IProductDetail[]) => void;
  removeFromCart: (id: string) => void;
  clearEDTechPreferenceStorage: () => void;
  resetCart: () => void;
  screenName: string;
  setScreenName: (screenName: string) => void;
  productType: string;
  setProductSearchType: (type: string) => void;
  coursesToView: string[];
  setCoursesToView: (courses: string[]) => void;
  removeCourseFromView: (name: string) => void;
  productCategoryType: string;
  setProductCategoryType: (type: string) => void;
  productCategoryName: string;
  setProductCategoryName: (productCategoryName: string) => void;
};
const initialState = {
  productViewAll: [],
  learningCourseWebViewUrl: '',
  myCourses: [],
  instructorList: [],
  cart: [],
  screenName: '',
  coursesToView: []
};

export const useEdTechProductStore = create<EdTechPreferenceStore>()(
  persist(
    (set, get) => ({
      ...initialState,
      setProductViewAll: (productViewAll: Array<IActionDataModel<IEdTechContentModel>>) =>
        set(() => ({ productViewAll: productViewAll })),
      setLearningCourseWebViewUrl: (learningCourseWebViewUrl: string) =>
        set(() => ({ learningCourseWebViewUrl })),
      setMyCourses: (myCourses: Array<IActionDataModel<IEdTechContentModel>>) => set(() => ({ myCourses })),
      setInstructorList: (instructorList: Array<IActionDataModel>) =>
        set(() => ({ instructorList })),
      addToCart: (items: IProductDetail[]) =>
        set((state) => ({
          cart: [...state.cart, ...items],
        })),

      removeFromCart: (id: string) =>
        set((state) => ({
          cart: state.cart.filter((item) => item.id !== id),
        })),
      resetCart: () => set(() => ({ cart: [] })),
      setScreenName: (screenName: string) => set(() => ({ screenName })),
      productType: '',
      setProductSearchType: (productType: string) => set(() => ({ productType })),
      productCategoryType: '',
      setProductCategoryType: (productCategoryType: string) => set(() => ({ productCategoryType })),
      productCategoryName: '',
      setProductCategoryName: (productCategoryName: string) => set(() => ({ productCategoryName })),
      setCoursesToView: (courses: string[]) =>
        set((state) => ({
          coursesToView: [...courses, ...state.coursesToView],
        })),
      removeCourseFromView: (courseName: string) =>
        set((state) => ({
          coursesToView: state.coursesToView.filter((name) => name !== courseName),
        })),
      clearEDTechPreferenceStorage: () => {
        mmkvEdTechProductPersistence.delete(MMKVEdTechStoreKeyMap.productStore);
        set({ ...initialState });
      },
    }),
    {
      name: MMKVEdTechStoreKeyMap.productStore,
      storage: createJSONStorage(() => zustanEdTechProductStorage),
    }
  )
);
